<template>
  <div class="detailswelfare-box">
    <van-sticky>
      <div class="top-box">
        <p v-if="state.subNameList.length == 0">请先创建游戏小号再领取礼包</p>
        <p v-else>{{ state.selectedItem.nickname }}</p>
        <p v-if="state.subNameList.length > 0" @click="switchXiaoHao()">切换</p>
      </div>
    </van-sticky>

    <van-pull-refresh v-model="state.isLoading" @refresh="onRefresh">
      <div class="gift-content" v-if="state.hasData">
          <div v-if="state.usageCardCount > 0" class="gift-box">
            <h3 class="title">签到礼包</h3>
            <div class="sign-box">
              <div class="left">
                  <div class="title">
                    <img src="../../../assets/game/game_sign_box.png" alt="">
                    <span class="name">{{state.usageCardCount}}个签到礼包</span>
                  </div>
                  <div class="content van-ellipsis">
                    {{state.usageCardexcerpt}}
                  </div>
              </div>
              <div @click="goGameSign" class="btn">
                去签到
              </div>
            </div>
          </div>
          <div class="gift-box" v-if="state.card && state.card.length > 0">
            <h3 class="title">普通礼包</h3>
            <div class="list">
              <div
                v-for="(item, i) in state.card"
                :key="i + '-giftlist'"
                class="item"
              >
                <div class="l"
                @click="goGiftDetail(item)" style="flex: 1;">
                  <h3>{{ item.name }}</h3>
                  <p>{{ item.excerpt }}</p>
                  <div v-if="item.status == '0'" class="sy">
                    剩余：<span>{{ item.remain_num }}</span>
                  </div>
                  <div v-else class="lbm">
                    礼包码：<span :id="'ptshare-code' + i">{{
                      item.card_info
                    }}</span>
                  </div>
                </div>
                <div
                  v-if="item.status == '0'"
                  class="r"
                  @click.stop="onReceive(item)"
                >
                  领取
                </div>
                <div
                  v-else
                  class="r fz"
                  :id="'ptcopy-btn' + i"
                  data-clipboard-action="copy"
                  :data-clipboard-target="'#ptshare-code' + i"
                  @click="copyText(item.card_info)"
                >
                  复制
                </div>
              </div>
              <div class="empty-v" v-if="state.card.length < 1">
                <span>暂无礼包</span>
              </div>
            </div>
          </div>
          <div class="gift-box" v-if="state.cardpay && state.cardpay.length > 0">
            <h3 class="title">充值礼包</h3>
            <div class="list">
              <div
                v-for="(item, i) in state.cardpay"
                :key="i + '-cardpay'"
                class="item"
              >
                <div class="l" @click="goGiftDetail(item)" style="flex: 1;">
                  <h3>{{ item.name }}</h3>
                  <p>{{ item.excerpt }}</p>
                  <div v-if="item.status == '0'" class="sy">
                    剩余：<span>{{ item.remain_num }}</span>
                  </div>
                  <div v-else class="lbm">
                    礼包码：
                    <span :id="'czshare-code' + i">{{ item.card_info }}</span>
                  </div>
                </div>
                <div
                  v-if="item.status == '0'"
                  class="r"
                  @click.stop="onReceive(item)"
                >
                  领取
                </div>
                <div
                  v-else
                  class="r fz"
                  :id="'czcopy-btn' + i"
                  data-clipboard-action="copy"
                  :data-clipboard-target="'#czshare-code' + i"
                  @click="copyText(item.card_info)"
                >
                  复制
                </div>
              </div>
              <div class="empty-v" v-if="state.cardpay.length < 1">
                <span>暂无礼包</span>
              </div>
            </div>
          </div>
          <div class="gift-box" v-if="state.cardlevel && state.cardlevel.length > 0">
            <h3 class="title">等级礼包</h3>
            <div class="list">
              <div
                v-for="(item, i) in state.cardlevel"
                :key="i + '-cardlevel'"
                class="item"
              >
                <div class="l" @click="goGiftDetail(item)" style="flex: 1;">
                  <h3>{{ item.name }}</h3>
                  <p>{{ item.excerpt }}</p>
                  <div v-if="item.status == '0'" class="sy">
                    剩余：<span>{{ item.remain_num }}</span>
                  </div>
                  <div v-else class="lbm">
                    礼包码：<span :id="'djshare-code' + i">{{
                      item.card_info
                    }}</span>
                  </div>
                </div>
                <div
                  v-if="item.status == '0'"
                  class="r"
                  @click.stop="onReceive(item)"
                >
                  领取
                </div>
                <div
                  v-else
                  class="r fz"
                  :id="'djcopy-btn' + i"
                  data-clipboard-action="copy"
                  :data-clipboard-target="'#djshare-code' + i"
                  @click="copyText(item.card_info)"
                >
                  复制
                </div>
              </div>
              <div class="empty-v" v-if="state.cardlevel.length < 1">
                <span>暂无礼包</span>
              </div>
            </div>
          </div>
        </div>
    </van-pull-refresh>


    <van-popup v-model:show="state.show">
      <div class="popup-box">
        <h3>请选择领取小号</h3>

        <div
          v-for="(item, i) in state.subNameList"
          :key="i + '-subNameList'"
          class="subname-item"
          @click="onXiaoHaoSelected(i)"
        >
          <p>{{ item.nickname }}</p>
          <img
            v-if="item.status == '1'"
            src="../../../assets/game/yz_xq_gift_xh_xz1.png"
          />
          <img v-else src="../../../assets/game/yz_xq_gift_xh_xz2.png" />
        </div>
        <div class="btn-box">
          <p @click="onCancel()">取消</p>
          <p @click="onSure()">确定</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { reactive, onMounted, nextTick, onActivated } from "vue";
import { useRouter, useRoute, onBeforeRouteUpdate } from "vue-router";
import { Dialog, Toast } from "vant";
import { giftlists, xhlists, getCode_xh } from "@/api/yzgame";
import { detect } from "@/utils/device";
import defaultimg1 from "@/assets/defaultimg/error2.png";
import Clipboard from "clipboard";
import { getQueryString } from "@/utils/location";
import { handleCopy } from "../../../utils/tool";

export default {
  name: "game-gift",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      noimg: defaultimg1,
      show: false,
      showEmpty: false,
      on: "1",
      card: [],
      cardpay: [],
      cardlevel: [],
      giftname: "",
      gifuse: "",
      giftcontent: "",
      time: "",
      img: "",
      subNameList: [],
      selectedItem: {},
      tempPosition: 0,
      needvip: "",
      oldId: "",
      usageCardCount: 0,
      usageCardexcerpt: "",
      isLoading: true,
      hasData: false
    });


    const goGameSign = ()=>{
      window.JsBridge.skipGameSign(route.query.gid);
    }

    const getData = (isrefresh = false) => {
      if(!isrefresh){
        Toast.loading({
          duration: 0,
          message: " 正在加载礼包，请稍等...",
          forbidClick: true,
        });
      }


      let type = "";
      if (detect() == "ios") {
        type = "ios";
      } else {
        type = "android";
      }
      giftlists({
        type: "ios",
        gid: route.query.gid,
        uid: getQueryString("uid"),
        xiaohao: state.selectedItem.username ? state.selectedItem.username : "",
      }).then((response) => {
        // console.log(response.data)
        if (response.data.code == 1) {
          Toast.clear();
          state.card = response.data.data.gift;
          state.cardpay = response.data.data.paygift;
          state.cardlevel = response.data.data.levelgift;
          state.usageCardCount = response.data.data.usageCardCount;
          state.usageCardexcerpt = response.data.data.usageCardexcerpt;
        } else {
          Toast(response.data.msg);
        }
      }).finally(()=>{
        state.isLoading = false
        state.hasData = true
      });
    };
    // 复制礼包码
    const copyWaybillNo = (id) => {
      let clipboard = new Clipboard(id);
      nextTick(() => {
        clipboard.on("success", function () {
          Toast("礼包码已复制");
          clipboard.destroy();
        });
        clipboard.on("error", function () {
          Toast("您的浏览器不支持点击复制");
          clipboard.destroy();
        });
      });
    };
    const getvipname = (vip) => {
      switch (vip) {
        case 0:
          return "";
        case 1:
          return "青铜";
        case 2:
          return "白银";
        case 3:
          return "黄金";
        case 4:
          return "铂金";
        case 5:
          return "钻石";
        case 6:
          return "王者";
        case 7:
          return "神话";
        default:
          return "";
      }
    };

    onMounted(() => {
      state.oldId = route.query.gid;
      // console.log(state.oldId)
      getXiaoHao();
    });

    // 获取小号
    const getXiaoHao = () => {
      xhlists({
        gid: route.query.gid,
        uid: getQueryString("uid"),
      }).then((response) => {
        // console.log(response)
        if (response.data.code == 1) {
          state.subNameList = response.data.data;
          state.selectedItem = state.subNameList[0];
          state.subNameList[0].status = "1";
          getData();
        } else {
          getData();
        }
      });
    };
    const onRefresh = ()=>{
        state.isLoading = true
        getData(true)
    }

    const onXiaoHaoSelected = (position) => {
      state.tempPosition = position;
      for (let i = 0; i < state.subNameList.length; i++) {
        if (i == position) {
          state.subNameList[i].status = "1";
        } else {
          state.subNameList[i].status = "0";
        }
      }
    };

    // 领取礼包
    let fetchFlag = false;
    const onReceive = (item) => {
      if (!state.selectedItem.username) {
        Toast("未选择小号");
        return;
      }
      if (fetchFlag) return;
        fetchFlag = true;
        getCode_xh({
          cid: item.giftid,
          uid: getQueryString("uid"),
          // gid: route.query.gid,
          xiaohao: state.selectedItem.username,
        }).then((response) => {
          fetchFlag = false;
          // console.log('领取礼包返回的数据-------------',response)
          if (response.data.a == "1") {
            state.show = false;
            item.status = "1";
            getData();

            if(response.data.c.card_context){
              Dialog.confirm({
                showCancelButton: false,
                message: response.data.c.card_context,
              })
                .then(() => {
                  
                })
                .catch(() => {
                });
            }
            
          }
          Toast(response.data.b);
        });
    };
    // 关闭小号弹窗
    const onCancel = () => {
      state.show = false;
    };
    // 确认小号
    const onSure = () => {
      state.show = false;
      state.selectedItem = state.subNameList[state.tempPosition];
      getData();
    };
    // 打开小号弹窗
    const switchXiaoHao = () => {
      state.show = true;
    };

    const goGiftDetail = (item) => {
      // console.log(item)
      // debugger
      state.needvip = getvipname(item.is_tx);
      router.push({
        path: "/newgamedetail/giftdetail",
        query: {
          xiaohao: state.selectedItem.username,
          cid: item.giftid,
          needvip: state.needvip,
          needcard: item.is_vip,
          status: item.status,
          uid: getQueryString("uid")
          // gid: route.query.gid,
        },
      });
    };
    // 判断新老id是否相同，如果不同就重载数据
    onActivated(() => {
      // console.log(route.query.gid,state.oldId)
      if (route.query.gid != state.oldId) {
        state.oldId = route.query.gid;
        console.log("不是同一个游戏");
        state.subNameList = [];
        state.selectedItem = {};
        getXiaoHao();
        // getData();
        // 清空所有礼包数据
        state.card = [];
        state.cardpay = [];
        state.cardlevel = [];
      }

      console.log(route.query.gid);
    });

    const copyText =(text) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      
      document.body.appendChild(textarea);
      textarea.select();
      
      try {
          document.execCommand('copy');
          Toast('复制成功');
      } catch (err) {
          Toast('复制失败，请手动输入');
      }
      
      document.body.removeChild(textarea);
    }

    return {
      state,
      onReceive,
      getXiaoHao,
      onXiaoHaoSelected,
      onCancel,
      switchXiaoHao,
      onSure,
      goGiftDetail,
      getvipname,
      copyWaybillNo,
      goGameSign,
      onRefresh,
      copyText
    };
  },
};
</script>

<style scoped="scoped">
:deep(.van-sticky) {
  padding-top: calc(32px + constant(safe-area-inset-top));
  /* 适配安全区域 iOS < 11.2 */
  padding-top: calc(32px + env(safe-area-inset-top));
  /* 适配安全区域 iOS >= 11.2 */
  background-color: #f7f8f9;
  padding-bottom: 20px;
}

.van-nav-bar {
  /* background: #f7f7f7; */
  /* background: linear-gradient(#e2e2e2 30%, 40%, #f7f7f7 60%); */
}

.left-nr {
  display: flex;
}

.right-nr {
  color: #00d9c5;
}

.left-nr img {
  width: 60px;
  height: 60px;
}

.nav-box {
  background-color: #fafafa;
}

.detailswelfare-box {
  background-color: #f7f8fa;
  min-height: 100vh;
}

.top-box {
  display: flex;
  background: #fff;
  justify-content: space-between;
  height: 60px;
  align-items: center;
  border-radius: 16px;
  width: 686px;
  margin: 0px auto 0;
  padding: 0 24px;
}

.top-box p:nth-of-type(1) {
  color: #00d9c5;
  margin-right: 28px;
  font-size: 24px;
}

.top-box p:nth-of-type(2) {
  color: #00d9c5;
  margin-right: 28px;
  font-size: 24px;
}

.top-box p:nth-of-type(3) {
  color: #00d9c5;
  margin-right: 28px;
  font-size: 24px;
}

.gift-content {
  padding: 32px;
  padding-top: 10px;
}

.gift-box {
  margin-bottom: 30px;
}

.gift-box .title {
  font-size: 28px;
  color: #333;
}

.gift-box .list .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background-color: #fff;
  border-radius: 16px;
  margin-top: 20px;
}

.gift-box .list .item .l h3 {
  font-size: 28px;
  color: #333;
}

.gift-box .list .item .l p {
  max-width: 500px;
  font-size: 20px;
  color: #999;
  margin: 8px 0 16px 0;
}

.gift-box .list .item .l .sy {
  font-size: 20px;
  color: #666;
}

.gift-box .list .item .l .sy span {
  color: #00d9c5;
}

.gift-box .list .item .l .lbm {
  color: #00d9c5;
  font-size: 20px;
}

.gift-box .list .item .r {
  width: 100px;
  height: 48px;
  border-radius: 48px;
  background: #00d9c5;
  /* line-height: 48px;
    text-align: center; */
  font-size: 24px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gift-box .list .item .r.fz {
  background-color: #f0f0f0;
  color: #00d9c5;
}

.detailswelfare-box:deep(.van-popup) {
  background: none;
}

.popup-box {
  width: 628px;
  padding: 32px;
  text-align: center;
  border-radius: 20px;
  background: #fff;
}

.popup-box h3 {
  font-size: 32px;
  color: #333;
  margin: 0 auto;
  margin-bottom: 52px;
}

.popup-box .btn-box {
  display: flex;
  height: 50px;
  align-items: center;
}

.popup-box .btn-box p {
  width: 50%;
  color: #999999;
}

.popup-box .btn-box p:nth-child(2) {
  color: #00d9c5;
}

.popup-box:deep(.van-button) {
  width: 180px;
  height: 60px;
}

.subname-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f1f1f1;
  padding: 24px 20px;
  border-radius: 10px;
  margin: 20px 0;
}

.subname-item p:nth-child(1) {
  color: #333;
  text-align: center;
  font-size: 28px;
}

.subname-item img {
  width: 30px;
  height: 30px;
}

.empty-v {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
}

.empty-v img {
  width: 400px;
  height: 300px;
}

.empty-v span {
  color: #666;
  font-size: 20px;
  text-align: center;
  margin-top: 20px;
}

.headsetion {
  display: flex;
  /* align-items: center;
  justify-items: center; */
  line-height: 40px;
  vertical-align: middle;
  color: #fff;
}

.headsetion img:nth-child(1) {
  width: 36px;
  height: 36px;
  margin-right: 18px;
}

.headsetion img:nth-child(3) {
  width: 32px;
  height: 32px;
  margin-left: 8px;
}

.vipbox {
  margin-left: 16px;
  width: 120px;
  height: 26px;
  position: relative;
}

.vipbox img:first-child {
  width: 150px;
  height: 26px;
}

.vipboxdd img:first-child {
  margin-left: 16px;
  width: 120px;
  height: 26px;
}

.headsetion .viptitle {
  position: absolute;
  top: 0px;
  left: 10px;
  font-size: 20px;
  color: orange;
}

.cardbtn {
  margin-right: 20px;
  margin-top: 20px;
  font-size: 20px;
  color: #e4b88c;
  background-color: #fff;
  line-height: 44px;
  height: 44px;
  width: 108px;
  border-radius: 22px;
  vertical-align: middle;
  text-align: center;
}

.cardbtnget {
  margin-right: 20px;
  margin-top: 20px;
  font-size: 20px;
  color: #666;
  background-color: #d6ede9;
  line-height: 44px;
  height: 44px;
  width: 108px;
  border-radius: 22px;
  vertical-align: middle;
  text-align: center;
}

.vipdiserve {
  width: 100px;
  height: 26px;
  /* margin-left: 20px; */
}

.sign-box {
  margin-top: 20px;
  padding: 24px;
  background-color: #F5FFFE;
  display: flex;
  border-radius: 16px;
  align-items: center;
}

.sign-box .left {
  flex: 1;
  align-items: center;
  overflow: hidden;
  margin-right: 12px;
}
.sign-box .left .title {
  display: flex;
  align-items: center;
}
.sign-box .left .title img {
  width: 40px;
  height: 40px;
}
.sign-box .left .title .name {
  font-size: 28px;
  font-weight: bold;
  color: #333333;
  margin-left: 8px;
}
.sign-box .left .content{
  font-size: 24px;
  color: #666666;
  margin-top: 8px;
}
.sign-box .btn {
  width: 104px;
  height: 48px;
  background-color: #00d9c5;
  border-radius: 100px;
  color: white;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
